export const baseUrl = 'https://bentoapp.org/';
// export const baseUrl = 'https://dev.bentoapp.org/';

export const blogBaseUrl = 'https://tribune.bentoapp.org';
export const appVersion = '1.20.20.1'; // 1, appVersion, market, isServer

export const phoneNumberUrl = '/authentication1';
export const activationCodeUrl = '/authentication2';
export const registerUrl = '/register';
export const generateTypeUrl = '/generate/type';
export const generatePersonalTypeUrl = '/generate/personal/type';
export const generateUrl = '/generate/process';
export const generateOverviewUrl = '/generate/overview';
export const generateDietTypePreviewUrl = '/generate/type/preview';
export const mainUrl = '/main';
export const introUrl = '/intro';
